import script from "./CheckpointsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckpointsPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__